import { FirebaseError } from 'firebase/app';

/** User-facing text for httpsCallable failures (HTTP 400 often = failed-precondition). */
export function formatCallableError(err: unknown): string {
  if (err instanceof FirebaseError) {
    const { code, message } = err;
    if (code === 'functions/failed-precondition') {
      if (
        message.includes('RENDER_URL') ||
        message.includes('שרת העיבוד')
      ) {
        return `${message}\n(קוד: ${code} — הגדרו את פרמטר RENDER_URL לפונקציות, פרסו מחדש את Cloud Functions, וודאו ש־Cloud Run רץ.)`;
      }
      if (
        message.includes('Need eventType') ||
        message.includes('at least 3 photos')
      ) {
        return `${message}\n(קוד: ${code} — נדרשים סוג אירוע, סגנון, מוזיקה ולפחות 3 תמונות לפני ייצור.)`;
      }
    }
    if (code === 'functions/invalid-argument') {
      return `${message}\n(קוד: ${code})`;
    }
    return `${message}\n(${code})`;
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
